import { gql } from '@apollo/client'

export const JOB_SOURCE_CONNECTIONS_QUERY = gql`
  query JobSourceConnectionsQuery {
    jobSourceConnections {
      items {
        jobSourceConnectionId
        type
        externalId
        status
        jobSourceName
        features
        settings
        connectedBy {
          userId
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`

export const START_INDEED_CONNECTION = gql`
  mutation StartIndeedConnectionMutation {
    startIndeedConnection {
      authorizeUrl
    }
  }
`

export const COMPLETE_INDEED_CONNECTION = gql`
  mutation CompleteIndeedConnectionMutation($pendingToken: String!) {
    completeIndeedConnection(pendingToken: $pendingToken) {
      jobSourceConnectionId
      status
      jobSourceName
      externalId
    }
  }
`

export const DISCONNECT_INDEED_CONNECTION = gql`
  mutation DisconnectIndeedConnectionMutation($jobSourceConnectionId: String!) {
    disconnectIndeedConnection(jobSourceConnectionId: $jobSourceConnectionId) {
      jobSourceConnectionId
      status
    }
  }
`

export const UPDATE_INDEED_SOURCE_NAME = gql`
  mutation UpdateIndeedSourceNameMutation(
    $jobSourceConnectionId: String!
    $jobSourceName: String!
  ) {
    updateIndeedSourceName(
      jobSourceConnectionId: $jobSourceConnectionId
      jobSourceName: $jobSourceName
    ) {
      jobSourceConnectionId
      jobSourceName
    }
  }
`

export const UPDATE_INDEED_APPLY_ENABLED = gql`
  mutation UpdateIndeedApplyEnabledMutation(
    $jobSourceConnectionId: String!
    $indeedApplyEnabled: Boolean!
  ) {
    updateIndeedApplyEnabled(
      jobSourceConnectionId: $jobSourceConnectionId
      indeedApplyEnabled: $indeedApplyEnabled
    ) {
      jobSourceConnectionId
      settings
    }
  }
`
